import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FeatureFlag, useFeatureFlags } from '../../../contexts/FeatureFlagsContext';
import { isPushSupported, setPushNavigateHandler } from '../../../services/pushNotificationService';
import PushNotificationPrompt from '../PushNotificationPrompt/PushNotificationPrompt';
import NativeForegroundMessageToast from '../NativeForegroundMessageToast/NativeForegroundMessageToast';
import '../NativeForegroundMessageToast/NativeForegroundMessageToast.css';

/**
 * Pont natif pour les notifications push :
 * - Enregistre un handler de navigation React Router (taps de notification → route).
 * - Monte la bannière d'activation contextuelle.
 *
 * Sécurité web : ne fait strictement rien hors contexte natif (retourne null,
 * n'enregistre aucun handler). Doit être monté à l'intérieur du Router.
 */
const NativePushBridge: React.FC = () => {
  const navigate = useNavigate();
  const { isFeatureEnabled } = useFeatureFlags();

  useEffect(() => {
    if (!isPushSupported()) return;
    setPushNavigateHandler((path: string) => {
      if (path.startsWith('/messaging') && !isFeatureEnabled(FeatureFlag.CHAT_FEATURE)) return;
      if (path.startsWith('/quotes') && !isFeatureEnabled(FeatureFlag.QUOTES)) return;
      navigate(path);
    });
    return () => setPushNavigateHandler(null);
  }, [navigate, isFeatureEnabled]);

  if (!isPushSupported()) return null;

  return (
    <>
      <NativeForegroundMessageToast />
      <PushNotificationPrompt />
    </>
  );
};

export default NativePushBridge;
